import React, { ReactNode } from "react";
import { ReleaseProvider } from "../simulator/context/release";

export const SimulatorWrapper = ({ children }: { children: ReactNode }) => {
  return <ReleaseProvider>{children}</ReleaseProvider>;
};
